import React from 'react';
import { Flower2 } from 'lucide-react';

export const Footer = () => {
    return (
        <footer className="bg-muted/30 border-t border-border mt-32">
            <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-12">
                <div className="flex flex-col items-center gap-6">
                    {/* Logo */}
                    <div className="flex items-center gap-3">
                        <Flower2 className="w-7 h-7 text-primary" />
                        <span className="text-xl font-serif font-medium text-foreground">
                            Focus Bloom
                        </span>
                    </div>
                    
                    {/* Tagline */}
                    <p className="text-sm text-muted-foreground text-center max-w-md">
                        Building concentration and mindfulness, one breath at a time.
                    </p>
                    
                    {/* Copyright */}
                    <div className="pt-6 border-t border-border/50 w-full text-center">
                        <p className="text-xs text-muted-foreground">
                            © {new Date().getFullYear()} Focus Bloom. All rights reserved.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};